import { tv } from "tailwind-variants";

export const UIProductSlider = tv({
    slots: {
        base: "tw:pb-2",
        header: "tw:flex tw:mb-2 tw:justify-between tw:w-full",
        header_title: "tw:mr-4 tw:my-2 tw:shrink",
        slider: "tw:flex tw:items-center tw:w-full",
        slider_navButton: [
            "tw:hidden tw:md:block tw:cursor-pointer tw:disabled:cursor-default!",
            "tw:disabled:opacity-20!"
        ],
        slider_navButton_icon: "las",
        slider_slides: "tw:w-full tw:grow",
        slider_slides_wrapper: "tw:w-dvw tw:max-w-full tw:mr-auto",
        slider_slides_swiperslide: "tw:flex tw:h-auto",
        slider_slides_slide_productTile: "tw:w-full tw:mb-4 tw:rounded-md"
    },
    variants: {
        hiddenXs: {
            true: {
                base: "tw:hidden"
            },
            false: {
                base: "tw:block"
            }
        },
        hiddenSm: {
            true: {
                base: "tw:sm:hidden"
            },
            false: {
                base: "tw:sm:block"
            }
        },
        hiddenMd: {
            true: {
                base: "tw:md:hidden"
            },
            false: {
                base: "tw:md:block"
            }
        },
        hiddenLg: {
            true: {
                base: "tw:lg:hidden"
            },
            false: {
                base: "tw:lg:block"
            }
        },
        hiddenXl: {
            true: {
                base: "tw:xl:hidden"
            },
            false: {
                base: "tw:xl:block"
            }
        },
        centered: {
            true: {
                slider: "tw:justify-center"
            }
        },
        initialized: {
            false: {
                slider_slides:
                    "tw:[--slides-per-view:1] tw:xs:[--slides-per-view:var(--slides-xs)] tw:sm:[--slides-per-view:var(--slides-sm)] tw:md:[--slides-per-view:var(--slides-md)] tw:lg:[--slides-per-view:var(--slides-lg)] tw:xl:[--slides-per-view:var(--slides-xl)]",
                slider_slides_swiperslide:
                    "tw:w-[calc((100%/var(--slides-per-view))-var(--slider-spacing)+(var(--slider-spacing)/(var(--slides-per-view))))] tw:mr-(--slider-spacing)"
            }
        },
        isRecent: {
            true: {}
        },
        type: {
            left: {
                slider_navButton_icon: "la-angle-left"
            },
            right: {
                slider_navButton_icon: "la-angle-right"
            }
        },
        skeleton: {
            true: {
                slider_slides_swiperslide: ""
            }
        }
    }
});
